export default function PageHeader({
  title
}) {
  return(
    <div>
      <h4 className="text-xl w-full py-2 text-gray-500 uppercase">{title}</h4>
    </div>
  );
}